import { TabContentProps } from "../../types";
import {
  ImpactAreas,
  ImpactStatsBanner,
  OurPillarsOfImpact,
  SocialResponsibilityHero,
} from "./components";

/**
 * Social Responsibility content component
 * Displays company's social responsibility initiatives
 */
export function SocialResponsibilityContent({ data }: TabContentProps) {
  return (
    <>
      <SocialResponsibilityHero />
      <ImpactStatsBanner />
      <OurPillarsOfImpact data={data} />
      <ImpactAreas />
    </>
  );
}
